module.exports = __webpack_public_path__ + "img/Compact-FR_Overview-EVA_2.c3aaa659.jpg";